var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.visSrc,"height":_vm.height || _vm.width,"width":_vm.width || _vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }